/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const NoticeSystemListPage = lazyLoad(
  () => import('./index'),
  module => module.NoticeSystemListPage
);
